export enum TeamAvailability {
  DirectAvailable = 'DirectAvailable',
  InTimeAvailable = 'InTimeAvailable',
  NoOneAvailable = 'NoOneAvailable',
}
